import angular from 'angular';

import { PasswordConfirmService } from './password-confirm.service.js';

angular
  .module('password-confirm.controller', [])
  .factory('PasswordConfirmFactory', PasswordConfirmService.PasswordConfirmFactory)

